import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { collectionLabel } from "@/lib/collections";
import { ArrowUpRight, Layers } from "lucide-react";

export default function TemplateCard({ template, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      className="group relative overflow-hidden bg-navy-800 border border-white/10 hover:border-gold/50 transition-colors"
      data-testid={`template-card-${template.id}`}
    >
      <Link to={`/template/${template.slug || template.id}`} className="block">
        <div className="relative h-56 overflow-hidden">
          {template.preview_image ? (
            <img
              src={template.preview_image}
              alt={`${template.title} — website design preview`}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-navy-700 text-gray-500 text-xs uppercase tracking-wide">{collectionLabel(template.category)}</div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/20 to-transparent" />
          {template.badge && (
            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.15em] bg-gold text-navy px-3 py-1 font-bold">
              {template.badge}
            </span>
          )}
        </div>
      </Link>

      <div className="p-6">
        <div className="flex items-center gap-2 text-xs text-gold uppercase tracking-[0.15em] mb-2">
          <Layers size={13} /> {collectionLabel(template.category)}
        </div>
        <Link to={`/template/${template.slug || template.id}`}>
          <h3 className="font-heading text-xl text-white font-medium mb-2 group-hover:text-gold transition-colors">
            {template.title}
          </h3>
        </Link>
        <p className="text-gray-400 text-sm leading-relaxed line-clamp-2 mb-5">{template.description}</p>

        <div className="flex items-end justify-between mb-5 pt-4 border-t border-white/10">
          <div>
            <div className="text-[11px] text-gray-500 uppercase tracking-wide">Custom build</div>
            <div className="font-heading text-2xl text-gold">Starting at $997</div>
          </div>
          <div className="text-right text-[11px] text-gray-500 leading-snug">Customized<br/>& launched for you</div>
        </div>

        <div className="flex gap-3">
          <Link
            to={`/template/${template.slug || template.id}`}
            data-testid={`view-template-${template.id}`}
            className="flex-1 text-center bg-gold text-navy py-3 text-sm font-semibold hover:bg-gold-light transition-colors"
          >
            Build This for My Business
          </Link>
          <Link
            to={`/template/${template.slug || template.id}`}
            data-testid={`hire-template-${template.id}`}
            className="flex items-center justify-center border border-white/20 text-white px-4 hover:bg-white/5 transition-colors"
          >
            <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
